export default "/Frontend/dist/logo-white.1586111d5796f95a347d204d477b530a.png";